export const parseMoney = (val) => {
  if (val == null || val === '') {
    return null;
  }
  const n = parseFloat(String(val).replace(/,/g, '').trim());
  return Number.isNaN(n) ? null : n;
};

export const formatMoney = (val) => {
  const n = parseMoney(val);
  if (n == null) {
    return '—';
  }
  return n.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

const normalizePoInvoiceRow = (item) => {
  if (!item) {
    return null;
  }
  if (item.invoice_details) {
    return item.invoice_details;
  }
  if (item.invoiceDetails) {
    return item.invoiceDetails;
  }
  if (item._originalData) {
    return item._originalData;
  }
  return item;
};

/**
 * Build PO-level summary for invoice details pages.
 */
export const buildPoInvoiceSummary = ({
  rawInvoice = {},
  poInvoicesList = [],
  poDetails = null,
  allowRemainingFallback = true,
} = {}) => {
  const poTotalAmount =
    parseMoney(rawInvoice.po_amount ?? rawInvoice.poAmount) ??
    parseMoney(poDetails?.total_cost_without_pst) ??
    parseMoney(poDetails?.total_cost) ??
    parseMoney(poDetails?.total_amount);

  const normalized = (Array.isArray(poInvoicesList) ? poInvoicesList : [])
    .map(normalizePoInvoiceRow)
    .filter(Boolean);

  // Count invoices for this PO excluding rejected
  const nonRejectedForCount = normalized.filter(
    (inv) =>
      String(inv.status || '')
        .toLowerCase()
        .trim() !== 'rejected'
  );
  const poInvoicesCount = nonRejectedForCount.length > 0 ? nonRejectedForCount.length : null;

  // Keep these available for future UI needs (not currently displayed)
  const statusCounts = normalized.reduce((acc, inv) => {
    const s = String(inv.status || '')
      .toLowerCase()
      .trim();
    if (!s) {
      return acc;
    }
    acc[s] = (acc[s] || 0) + 1;
    return acc;
  }, {});
  const pendingInvoicesCount = (statusCounts.pending || 0) + (statusCounts.pending_rejection || 0);
  const approvedInvoicesCount = statusCounts.approved || 0;

  const nonRejected = nonRejectedForCount;

  let alreadyClaimedAmount = null;
  if (nonRejected.length > 0) {
    alreadyClaimedAmount = nonRejected.reduce(
      (sum, inv) => sum + (parseMoney(inv.invoice_amount ?? inv.invoiceAmount) || 0),
      0
    );
  } else if (poTotalAmount != null && allowRemainingFallback) {
    const remaining = parseMoney(rawInvoice.remaining_po_amount ?? rawInvoice.remainingPoAmount);
    if (remaining != null) {
      alreadyClaimedAmount = Math.max(0, poTotalAmount - remaining);
    }
  }

  const reasonOfRejection = (rawInvoice.reason_of_rejection || rawInvoice.reasonOfRejection || '')
    .toString()
    .trim();

  return {
    poTotalAmount,
    alreadyClaimedAmount,
    poInvoicesCount,
    pendingInvoicesCount,
    approvedInvoicesCount,
    reasonOfRejection: reasonOfRejection || null,
    poTotalAmountFormatted: formatMoney(poTotalAmount),
    alreadyClaimedAmountFormatted: formatMoney(alreadyClaimedAmount),
  };
};
